/* ==========================================================================
  load-more.js
========================================================================== */

(function($) {

  function supports_history_api() {
    return !!(window.history && history.pushState);
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // @see https://stackoverflow.com/a/19472410
  function replaceQueryParam(param, newval, search) {
    var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
    var query = search.replace(regex, "$1").replace(/&$/, '');

    return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
  }

  function document_to_dom_object(data) {
    return $($.trim(String(data)
      .replace(/<\!DOCTYPE[^>]*>/i, '')
      .replace(/<(html|head|body|title|meta|script)([\s\>])/gi,'<div class="document-$1"$2')
      .replace(/<\/(html|head|body|title|meta|script)\>/gi,'</div>')));
    }

  // AJAX load more for default items on media page.
  $('body').on('click', '.load-more a', function(e){
      e.preventDefault();
      var $destination = $('.js--ajax-container').filter(':last');
      $('.load-more').addClass('loading');

      var url = $(this).attr('href');

     // console.log(url);
      $(this).blur();
      $.ajax({
        url: url,
        success: function(data, textStatus, jqXHR){

          // Prepare
          var $data = document_to_dom_object(data);
          var $dataBody = $data.find('.document-body:first');
          var $content = $dataBody.find('.js--ajax-container').filter(':first').addClass('entrance');

          if(supports_history_api) {
            var current_url = location.protocol + '//' + location.host + location.pathname;

            var load_arg = getParameterByName('load');

            if(typeof load_arg == 'object') {
              load_arg = 1;
            }

            var next_page_nmb = parseInt(load_arg) + 1;
            if (current_url)
            var next_page_url = current_url + replaceQueryParam('load', next_page_nmb, location.search);
            window.history.replaceState(next_page_url, document.title, next_page_url);
          }

          // insert more items
          $content.insertAfter($destination);
          setTimeout(function() {
            $('.js--ajax-container').removeClass('entrance');
          }, 250);

          // manipulate load more button
          var $load_more = $dataBody.find('.load-more a');

          if($load_more.length) {
            $('.load-more').removeClass('loading');
            $('.load-more a').attr('href', $load_more.attr('href'));
          } else {
            $('.load-more a').remove();
          }

          $('.load-more').removeClass('loading');

        },
        error: function(jqXHR, textStatus, errorThrown){
          console.log(jqXHR);
          //document.location.href = url;
          return false;
        }
      }); // end ajax
    });

})(jQuery);
